module.exports = __webpack_public_path__ + "img/default-obs-point-hover.a22628fd.svg";